import React from 'react';

import SubTitle from '../../../shared/SubTitle';
import s from '../../index.module.css';

function Header({ block }) {
  return (
    <div className={s.subTitleWrapper}>
      <SubTitle text={block.data?.subheadline} />
    </div>
  );
}

export default Header;
